import React, { useState, useEffect } from "react"
import {
  SearchResultsContainer,
  SearchGrid,
  SearchTeaser,
  Tag,
  Message,
} from "./style"
import { FlexGrid, FlexRow, FlexCol } from "components/FlexGrid"

const defaultData = [
  {
    title: "The Knowledge Capital",
    excerpt: `Canberra is Australia’s education capital, being home to our nation’s best globally ranked university. Our city is placed in the top 25 student cities in the world.
  `,
    site: "study",
    tag: "study",
    link: "/study/",
  },
  {
    title: "Motivated, Prosperous and on the move",
    excerpt: `Canberra’s economy is mature, diverse and knowledge-based. We have growing demand and investment opportunity in key sectors including health, building and construction, information technology and public administration.
  `,
    site: "work",
    tag: "work",
    link: "/work/",
  },
  {
    title: "A globally connected city",
    excerpt: `There’s no better place to do business. This is where key decision makers meet, negotiations take place and brilliant possibilities come to life.
  `,
    site: "business",
    tag: "do business",
    link: "/business/",
  },
  {
    title: "One of the World’s most liveable cities",
    excerpt: `Planned and purposely designed in 1913, Canberra is a city of unspoilt nature reserves, contemporary and dynamic urban spaces, and bustling precincts with a seamless integration of developed and natural elements.
  `,
    site: "live",
    tag: "live",
    link: "/live/",
  },
  {
    title: "A vibrant and delicious destination",
    excerpt: `Visitation to Canberra has risen by 10% in 2019 — we welcomed 4.98 million people and earned the title of World’s 3rd best city to visit.
  `,
    site: "visit",
    tag: "visit",
    link: "/visit/",
  },
]

const SearchResults = ({ searchQuery, currentPosts }) => {
  console.log("currentPosts:", currentPosts)
  return (
    <SearchResultsContainer extraPadding={!currentPosts}>
      {((currentPosts && currentPosts.length === 0) || !currentPosts) && (
        <Message>
          <p>
            {" "}
            {currentPosts && currentPosts.length === 0
              ? `Sorry, there were no results found. Try searching for something
            else or click on one of the links below.`
              : `Use keywords to search for specific topics such as migration, jobs, cost of living, etc.
              `}
          </p>
        </Message>
      )}

      {currentPosts && (
        <SearchGrid gap={[30, 30, 45]} rowGap={[30, 30, 60]}>
          <FlexRow>
            {(currentPosts && currentPosts.length
              ? currentPosts
              : defaultData
            ).map((teaser, index) => {
              return (
                <FlexCol key={index} xs={12} sm={6} md={4}>
                  <SearchTeaser
                    noImg
                    site={teaser.site}
                    title={teaser.title}
                    excerpt={teaser.excerpt}
                    link={teaser.link}
                    innerLinkText="Read more"
                  >
                    <Tag site={teaser.site}>{teaser.site}</Tag>
                  </SearchTeaser>
                </FlexCol>
              )
            })}
          </FlexRow>
        </SearchGrid>
      )}
    </SearchResultsContainer>
  )
}

export default SearchResults
